import { Button, Card, Col, Row } from "react-bootstrap";
import { FaExternalLinkAlt, FaPlayCircle } from "react-icons/fa";

const DetailVirtualTours = ({ virtualTours = [] }) => {
  if (!virtualTours.length) return null;

  return (
    <Card className="detail-card">
      <Card.Body className="detail-card-body">
        <h3 className="section-title">Virtual Tours</h3>

        <Row className="g-3">
          {virtualTours.map((tour) => {
            const url = tour.embed_url || tour.tour_url;
            return (
              <Col xs={12} md={6} key={tour.id || tour.title}>
                <div className="detail-virtual-card">
                  <div className="detail-virtual-head">
                    <div>
                      <div className="detail-virtual-title">{tour.title || "Virtual Tour"}</div>
                      <div className="detail-virtual-subtitle">
                        {tour.tour_type || "tour"}
                        {tour.is_primary ? " • Utama" : ""}
                        {tour.is_active === false ? " • Nonaktif" : ""}
                      </div>
                    </div>

                    {url ? (
                      <Button
                        variant="outline-primary"
                        href={url}
                        target="_blank"
                        rel="noreferrer"
                        className="detail-virtual-btn"
                      >
                        <FaExternalLinkAlt />
                      </Button>
                    ) : null}
                  </div>

                  {tour.embed_url ? (
                    <div className="detail-virtual-embed">
                      <iframe
                        src={tour.embed_url}
                        title={tour.title || "Virtual Tour"}
                        loading="lazy"
                        allowFullScreen
                      />
                    </div>
                  ) : (
                    <div className="detail-virtual-placeholder">
                      <FaPlayCircle />
                      <span>Preview tidak tersedia</span>
                    </div>
                  )}
                </div>
              </Col>
            );
          })}
        </Row>
      </Card.Body>
    </Card>
  );
};

export default DetailVirtualTours;
